import { render, staticRenderFns } from "./view.vue?vue&type=template&id=d05ad418&scoped=true"
import script from "./view.vue?vue&type=script&lang=ts"
export * from "./view.vue?vue&type=script&lang=ts"
import style0 from "./view.vue?vue&type=style&index=0&id=d05ad418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05ad418",
  null
  
)

export default component.exports